import { render, staticRenderFns } from "./PatrimonyCard.vue?vue&type=template&id=76052a90&scoped=true"
import script from "./PatrimonyCard.vue?vue&type=script&lang=js"
export * from "./PatrimonyCard.vue?vue&type=script&lang=js"
import style0 from "./PatrimonyCard.vue?vue&type=style&index=0&id=76052a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76052a90",
  null
  
)

export default component.exports